const noop = () => {};

export const overrideConsole = () => {
  if (typeof window === "undefined") return;

  window.console.log = noop;
  window.console.info = noop;
  window.console.debug = noop;
};
